<h1 class="email-form-title text-primary-blue-700">Reset your Password</h1>
<div *ngIf="errorMessage">
  <app-message severity="error" [noMargin]="true" data-cy="reset-error-message">
    {{ errorMessage }}
  </app-message>
</div>
<form [formGroup]="forgotForm" (ngSubmit)="onSubmit()" formId="forgotForm" data-cy="reset-email-form">
  <app-form-field
    [control]="asFormControl(forgotForm.get('username'))"
    name="username"
    label="Email"
    type="input"
  ></app-form-field>
  <div id="captcha-container" class="forgot-password-captcha-container field"></div>
  <app-form-footer [disabled]="disableButton" submitLabel="Reset via Email" [noCancel]="true" [fullWidthButtons]="true">
  </app-form-footer>
  <a class="link" (click)="onSignIn()">Back to sign in</a>
  <app-mobile-footer></app-mobile-footer>
</form>
